export enum VehicleProfilesOrderingEnum {
  Code = 'Code',
  Manufacturer = 'Manufacturer',
  Type = 'Type',
  Group = 'Group',
  ModelDescription = 'ModelDescription',
  CreatedDate = 'CreatedDate',
  ModifiedDate = 'ModifiedDate',
}
